import axiosCustom from "@/utils/axiosCustom";
import IRate from "@/models/protocols/IRate";
import { Defaults } from "@/types/Defaults";
import { CartItem } from "@/types/cart-item";

export default class RatesService {
  static async get(item: CartItem, region: string): Promise<IRate[]> {
    const body = {
      promocode: Defaults.getInstance().promoCode,
      policyState: region,
      userType: Defaults.getInstance().userType,
      productCode: Defaults.getInstance().productCode,
      classCode: item.type,
      deductible: item.deductible,
      coverageAmount: item.coverage,
      coverageType: Defaults.getInstance().coverageType,
    };
    const { data } = await axiosCustom.post("/rest/V1/WAG/wise/rates", body);

    return data.Rates;
  }
}
